import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';
// import logo from '../../../public/assets/nexorah-logo.png'; // Adjust the path to your logo image

// --- SVG Icon Components ---
const DashboardIcon = () => <svg viewBox="0 0 24 24"><path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/></svg>;
const ResourcesIcon = () => <svg viewBox="0 0 24 24"><path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 16v2h-2v-2h-2v2h-2v-2H9v2H7v-2H5v4h14v-4h-2z"/></svg>;
const PlannerIcon = () => <svg viewBox="0 0 24 24"><path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z"/></svg>;
const QuestionBankIcon = () => <svg viewBox="0 0 24 24"><path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM9 16H7v-2h2v2zm0-4H7v-2h2v2zm6 4h-4v-2h4v2zm0-4h-4v-2h4v2zm-2-4V3.5L18.5 9H13z"/></svg>;
const VaultIcon = () => <svg viewBox="0 0 24 24"><path d="M4 20h16v-2H4v2zM4 10h16V8H4v2zm2.5-6h11v2h-11V4zM4 6v2h16V6H4z"/></svg>;
const SettingsIcon = () => <svg viewBox="0 0 24 24"><path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17-.59-1.69-.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19-.15-.24-.42-.12.64l2 3.46c.12-.22.39-.3.61.22l2.49 1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18-.49-.42l.38-2.65c.61-.25-1.17-.59-1.69-.98l2.49 1c.23-.09.49 0 .61.22l2-3.46c.12-.22-.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"/></svg>;

// Accept isOpen and setOpen as props
function Sidebar({ isOpen, setOpen }) {
  const navItems = [
    { to: "/dashboard", label: "Dashboard", icon: <DashboardIcon /> },
    { to: "/resources", label: "Resources", icon: <ResourcesIcon /> },
    { to: "/study-planner", label: "Study Planner", icon: <PlannerIcon /> },
    { to: "/question-bank", label: "Question Bank", icon: <QuestionBankIcon /> },
    { to: "/study-vault", label: "Study Vault", icon: <VaultIcon /> },
  ];
  const settingsItems = [
    { to: "/account-settings", label: "Account Settings", icon: <SettingsIcon /> }
  ];

  return (
    <>
      {/* The hamburger button is now part of the Sidebar component visually */}
      <button className={`sidebar-hamburger${isOpen ? " open" : ""}`} onClick={() => setOpen(!isOpen)}>
        <span /><span /><span />
      </button>

      <aside className={`sidebar${isOpen ? " sidebar-open" : ""}`}>
        <div className="logo"><img style={{ width: '50px', height: '50px' }} src='/assets/nexorah-logo.png' alt="Nexorah Logo" /></div>
        <nav className="sidebar-nav">
          <ul>
            {navItems.map(item => (
              <li key={item.to}>
                <NavLink to={item.to} className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setOpen(false)}>
                  <span className="sidebar-icon">{item.icon}</span>
                  <span className="sidebar-label">{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
          <div className="sidebar-divider"></div>
          <div className="sidebar-label">
            <span>SETTINGS</span>
            <ul>
              {settingsItems.map(item => (
                <li key={item.to}>
                  <NavLink to={item.to} className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setOpen(false)}>
                    <span className="sidebar-icon">{item.icon}</span>
                    <span className="sidebar-label">{item.label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </aside>

      {isOpen && <div className="sidebar-overlay" onClick={() => setOpen(false)} />}
    </>
  );
}

export default Sidebar;